export default "__VITE_ASSET__CRjOeXRw__"